import { Anchor, Badge, Box, Card, Flex, Grid, Tooltip } from '@mantine/core';
import { IconChartPie, IconHistory } from '@tabler/icons-react';
import { useLocation } from 'react-router';
import prettifiedLabel from '../../../constants/labelPrettifier';
import AdSetStatusVisualizer from '../../AdSetStatusVisualizer';
import FacebookAdStats from './FacebookAdStats';

const FacebookAdsCard = ({ facebookAd, stats, period, currency, adAccountCurrency, progress }) => {
  const location = useLocation();

  return (
    <Card mb="md" data-tour="campaignCard" withBorder>
      <Card.Section inheritPadding py="sm">
        <Box mb="xs">
          <Flex align="center" gap="xs" style={{ display: 'inline-flex' }}>
            <Anchor
              href={`#${location.pathname}/${facebookAd.id}/details`}
              fw={600}
              style={{ display: 'inline' }}
            >
              {facebookAd.name}
            </Anchor>
            {progress && (
              <Box style={{ display: 'inline-flex', alignItems: 'center' }}>
                <AdSetStatusVisualizer adSetStatuses={progress} />
              </Box>
            )}
          </Flex>
        </Box>
        <Flex gap="xs" wrap="wrap">
          {facebookAd.attributionSpec && (
            <Badge variant="default">
              <IconChartPie size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
              {prettifiedLabel(facebookAd.attributionSpec)}
            </Badge>
          )}
          <Tooltip
            label={
              <>
                <div>Created: {new Date(facebookAd.createdAt).toLocaleString()}</div>
                <div>Updated: {new Date(facebookAd.updatedAt).toLocaleString()}</div>
              </>
            }
            position="top"
            withArrow
          >
            <Badge variant="default" style={{ cursor: 'pointer' }}>
              <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
            </Badge>
          </Tooltip>
        </Flex>
      </Card.Section>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <FacebookAdStats
            facebookAd={facebookAd}
            stats={stats}
            period={period}
            adAccountCurrency={adAccountCurrency}
            currency={currency}
          />
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default FacebookAdsCard;
